export enum ERequestState {
  error = 0,
  standby = 1,
  pending = 2,
  success = 3,
  cancelled = 4
}
